import { useTranslation } from "react-i18next";
import imagenotfound from "../../../images/noimagefoundsquare.jpg";
import Button from "../../../components/controls/Button";

export default function SubscriptionCompanyCardCheckbox({
  company,
  isSelected,
  onToggle,
  paymentUrl,
}) {
  const { t } = useTranslation();
  const { name, imageUrl, address } = company;

  const handleToggle = () => {
    onToggle(company.id);
  };

  return (
    <div
      onClick={handleToggle}
      className="flex items-center justify-between h-32 w-full min-w-[400px] sm:min-w-[400px] border rounded-lg shadow-sm hover:shadow-md bg-white text-primary pr-4 hover:cursor-pointer"
    >
      {/* Image + Info */}
      <div className="flex items-center space-x-4 overflow-hidden">
        <div className="w-32 h-32 overflow-hidden rounded-lg flex-shrink-0 bg-white flex items-center justify-center">
          <img
            src={imageUrl || imagenotfound}
            alt={name}
            className="max-h-full max-w-full object-contain"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = imagenotfound;
            }}
            loading="lazy"
          />
        </div>
        <div className="max-w-[50%]">
          <h3 className="font-bold text-md mb-1 truncate">{name}</h3>
          <p className="text-xs text-gray-500 line-clamp-2 ">{address}</p>
        </div>
      </div>

      {/* Checkbox ou bouton Stripe */}
      <div
        className="flex items-center justify-center h-full"
        onClick={(e) => e.stopPropagation()}
      >
        {paymentUrl ? (
          <Button
            as="a"
            href={paymentUrl}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            size="sm"
            className="" // override la couleur de texte par défaut
          >
            {t("subscriptionModal.payNow", "Payer maintenant")}
          </Button>
        ) : (
          <input
            type="checkbox"
            checked={isSelected}
            onChange={handleToggle}
            className="form-checkbox h-5 w-5 rounded-full text-primary border-gray-300 focus:ring-primary"
          />
        )}
      </div>
    </div>
  );
}
